export default __webpack_public_path__ + "src/assets/images/apple-app-store-badge.svg";